const { navigate } = require("gatsby");

const isExternalLink  = (lnk = '') => 
    ['http://', 'https://', 'ftp://'].some(protocol => lnk.startsWith(protocol))


const normalizeString = (s) => {
    if (s) {
        return s.normalize("NFD").replace(/[\u0300-\u036f]/g, "")
    }
    return null
}



const followLink = (url, target) => {
    if (isExternalLink(url) || target === "_blank") {
        typeof target !== `undefined`
        && window !== 'undefined'
        && window.open(toExternalUrl(url), target);
    } else {
        navigate(url);
    }
}

const removeStyleTags = (richText) => {
    // Supprime toutes les balises <style>
    richText = richText.replace(/<style.*?<\/style>/g, "");
  
    // Supprime les attributs de style des autres balises
    richText = richText.replace(/ style=".*?"/g, "");
  
    return richText;
  }

const dompurifyConfig = { 
    ADD_TAGS: ["iframe", "script", "more"],  //or ALLOWED_TAGS
    ADD_ATTR: ["allow", "allowfullscreen", "frameborder", "scrolling", "target", "async"],//or //or ALLOWED_ATR
}


const isServer = () =>  {
        return ! (typeof window != 'undefined' && window.document);
}


const getHostname = (env) => {
    if (env ) {
        try {
            return (new URL(env)).hostname
        } catch( err ){

        }
    }
    return null
}

const config =  {
    cmsDomain:  getHostname(process.env.IMAGE_BASE_URL) || 'eco-web.sciences-po.fr',
    targetDomain: getHostname(process.env.CONFIG_WEBSITE_BASE_URL) || 'www.sciencespo.fr'
}



const convertExternalEcoSysLinks = (html) => {
    if (html && typeof html === 'string' && config.cmsDomain && config.targetDomain) {
        const regEx = new RegExp(config.cmsDomain, 'g')
        return html.replace(regEx, config.targetDomain);
    }
    return html
}

const toExternalUrl  = (uri) => {
    if (uri && isExternalLink(uri) && config.cmsDomain && config.targetDomain) {
       const replacement =  uri.replace(config.cmsDomain, config.targetDomain)
       if (uri !== replacement) {
           return replacement
       }
    }
    return uri
}


const specialTypeFolders = {
    'news-fr': 'actualites',
    'news-en': 'news',
    'event-fr': 'evenements',
    'event-en': 'events'
}

const createUrl = (slug, locale, websiteUrl, type) => {
    const stk = [websiteUrl]
    if ([''].includes(websiteUrl)) {
        stk.splice(0, 0, '/')
    }
    stk.push(specialTypeFolders[`${type}-${locale}`], slug)
    return stk.join('/').replace(/\/\/+/g, "/")
  }

const createNewsUrl = (slug, locale, siteURL) => {
    return createUrl(slug, locale, siteURL, 'news')
}

const createEventUrl = (slug, locale, siteURL) => {
    return createUrl(slug, locale, siteURL, 'event')
}



module.exports = {
    isExternalLink,
    followLink,
    removeStyleTags,
    dompurifyConfig,
    toExternalUrl,
    createNewsUrl,
    createEventUrl,
    convertExternalEcoSysLinks,
    isServer,
    normalizeString
}
